import { defineStore } from 'pinia'
import type { ICurrency } from '~/types'

export interface IResponseCurrencies<T> {
  data: T
}

export const useCurrencyStore = defineStore('currencies', {
  state: () => ({
    list: [] as ICurrency[],
    loaded: false
  }),
  actions: {
    async fetchCurrencies() {
      if (this.loaded) return

      try {
        const { $api, $i18n } = useNuxtApp()
        const locale = $i18n?.locale?.value || 'ru'

        const data = await $api<IResponseCurrencies<ICurrency[]>>('/currencies', {
          headers: {
            'Accept-Language': locale
          }
        })

        if (data) {
          this.list = data.data
          this.loaded = true
        }
      } catch (error) {
        console.error('Failed to fetch currencies:', error)
      }
    },
    markAsStale() {
      this.loaded = false
    }
  }
})
